<template>
  <div>
    <div class="d-flex align-center bg-gray-200 px-2 py-1">
      <v-icon size="16">$NotebookEdit</v-icon>
      <span class="font-14 ml-1">Ficha técnica de produção</span>
    </div>

    <v-tabs centered>
      <!-- <v-tab>
          <v-icon left>mdi-clipboard-list-outline</v-icon>
          Relação de Máteria Prima
      </v-tab> -->
      <v-tab>
        <v-icon left>mdi-clipboard-list-outline</v-icon>
        Relação de Produtos Acabados
      </v-tab>
      <!-- <v-tab-item  class="ma-0">
        <v-card flat>
          <v-card-text class="pa-0">
              <materia-prima @atualizarProdutosAcabados='atualizarPA=$event'></materia-prima>
          </v-card-text>
        </v-card>
      </v-tab-item> -->
      <v-tab-item  class="px-1">
        <v-card elevation="5">
          <ProdutoAcabado :chamarInitialize='atualizarPA' />
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import ProdutoAcabado from './ProdutoAcabado/Index';

export default {
  components: {
    ProdutoAcabado
  },
  data() {
    return {
      atualizarPA: 0
    }
  }
};
</script>
<style></style>
